import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaDivisionResolver_Get = DivisionsTableDefinitionZod.nullable();

export type SchemaDivisionResolver_Get = z.infer<typeof schemaDivisionResolver_Get>;

export type DivisionResolver_Get = Resolver<Arguments, SchemaDivisionResolver_Get>;
